export const isFormalityEnabled = process.env.REACT_APP_FEATURE_FLAG_FORMALITY === "true";

export const isUpdateNotificationEnabled =
    process.env.REACT_APP_FEATURE_FLAG_UPDATE_NOTIFICATION === "true";

export const isGlossaryEnabled = process.env.REACT_APP_FEATURE_FLAG_GLOSSARY === "true";
